<h3>Instrucciones</h3>

<div *ngIf="!instructionSelected" class="card p-30">
  <div #text1></div>
  <div class="col-12">
    <button class="btn btn-info btn-rounded waves-effect pull-right m-t-20" (click)="editInstructions()">Editar</button>
  </div>
</div>

<div *ngIf="instructionSelected" class="row justify-content-center">
    <div class="NgxEditor__Wrapper p-20 m-b-40 col-12">
        <ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
        <ngx-editor
          [editor]="editor"
          [(ngModel)]="html"
          [placeholder]="'Escriba su texto...'"
        ></ngx-editor>
        <button class="btn btn-success btn-rounded waves-effect pull-right m-t-20" (click)="saveHtml()">Guardar</button>
    </div>
</div>




<h3>Introducción al reporte</h3>

<div *ngIf="!reportSelected" class="card p-30">
  <div #text2></div>
  <div class="col-12">
    <button class="btn btn-info btn-rounded waves-effect pull-right m-t-20" (click)="editReport()">Editar</button>
  </div>
</div>

<div *ngIf="reportSelected" class="row justify-content-center">
  <div class="NgxEditor__Wrapper p-20 m-b-40 col-12">
      <ngx-editor-menu [editor]="editor2"> </ngx-editor-menu>
      <ngx-editor
        [editor]="editor2"
        [(ngModel)]="html2"

        [placeholder]="'Escriba su texto...'"
      ></ngx-editor>
      <button class="btn btn-success btn-rounded waves-effect pull-right m-t-20" (click)="saveHtml2()">Guardar</button>
  </div>
</div>

<h3>Estado normal</h3>

<div *ngIf="!normalSelected" class="card p-30">
  <div #textNormal></div>
  <div class="col-12">
    <button class="btn btn-info btn-rounded waves-effect pull-right m-t-20" (click)="editNormal()">Editar</button>
  </div>
</div>

<div *ngIf="normalSelected" class="row justify-content-center">
  <div class="NgxEditor__Wrapper p-20 m-b-40 col-12">
      <ngx-editor-menu [editor]="editorNormal"> </ngx-editor-menu>
      <ngx-editor
        [editor]="editorNormal"
        [(ngModel)]="htmlNormal"

        [placeholder]="'Escriba su texto...'"
      ></ngx-editor>
      <button class="btn btn-success btn-rounded waves-effect pull-right m-t-20" (click)="saveNormal()">Guardar</button>
  </div>
</div>

<h3>Estado motivado</h3>

<div *ngIf="!motivatedSelected" class="card p-30">
  <div #textMotivated></div>
  <div class="col-12">
    <button class="btn btn-info btn-rounded waves-effect pull-right m-t-20" (click)="editMotivated()">Editar</button>
  </div>
</div>

<div *ngIf="motivatedSelected" class="row justify-content-center">
  <div class="NgxEditor__Wrapper p-20 m-b-40 col-12">
      <ngx-editor-menu [editor]="editorMotivated"> </ngx-editor-menu>
      <ngx-editor
        [editor]="editorMotivated"
        [(ngModel)]="htmlMotivated"

        [placeholder]="'Escriba su texto...'"
      ></ngx-editor>
      <button class="btn btn-success btn-rounded waves-effect pull-right m-t-20" (click)="saveMotivated()">Guardar</button>
  </div>
</div>

<h3>Estado Bajo Presión/Stress</h3>


<div *ngIf="!stressSelected" class="card p-30">
  <div #textStress></div>
  <div class="col-12">
    <button class="btn btn-info btn-rounded waves-effect pull-right m-t-20" (click)="editStress()">Editar</button>
  </div>
</div>

<div *ngIf="stressSelected" class="row justify-content-center">
  <div class="NgxEditor__Wrapper p-20 m-b-40 col-12">
      <ngx-editor-menu [editor]="editorStress"> </ngx-editor-menu>
      <ngx-editor
        [editor]="editorStress"
        [(ngModel)]="htmlStress"

        [placeholder]="'Escriba su texto...'"
      ></ngx-editor>
      <button class="btn btn-success btn-rounded waves-effect pull-right m-t-20" (click)="saveStress()">Guardar</button>
  </div>
</div>


<h3>Factor humano</h3>


<div *ngIf="!hfSelected" class="card p-30">
  <div #textHf></div>
  <div class="col-12">
    <button class="btn btn-info btn-rounded waves-effect pull-right m-t-20" (click)="editHf()">Editar</button>
  </div>
</div>

<div *ngIf="hfSelected" class="row justify-content-center">
  <div class="NgxEditor__Wrapper p-20 m-b-40 col-12">
      <ngx-editor-menu [editor]="editorHf"> </ngx-editor-menu>
      <ngx-editor
        [editor]="editorHf"
        [(ngModel)]="htmlHf"
        [placeholder]="'Escriba su texto...'"
      ></ngx-editor>
      <button class="btn btn-success btn-rounded waves-effect pull-right m-t-20" (click)="saveHf()">Guardar</button>
  </div>
</div>